import React, { useState } from "react";
import FactoryIcon from "@mui/icons-material/Factory";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

export default function ValidationHeader({ plant, activeMode, onModeChange }) {
  // Internal state for uncontrolled usage
  const [internalMode, setInternalMode] = useState("Reconcile");

  const isControlled = activeMode !== undefined;
  const mode = isControlled ? activeMode : internalMode;

  const handleModeChange = (event, newMode) => {
    if (newMode !== null) {
      if (!isControlled) setInternalMode(newMode);
      onModeChange?.(event, newMode);
    }
  };

  return (
    <Box
      sx={{
        mb: 3,
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {/* Left */}
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 2,
            bgcolor: "primary.main",
            color: "primary.contrastText",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: 2,
          }}
        >
          <VerifiedIcon />
        </Box>

        <Box>
          <Box sx={{ fontSize: "1.4rem", fontWeight: 800, lineHeight: 1.2 }}>
            Material Validation
          </Box>
          <Box sx={{ color: "text.secondary", fontSize: "0.92rem", mt: 0.3 }}>
            Compare and validate materials between different sources
          </Box>
        </Box>
      </Box>

      {/* Right */}
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        {/* Plant Info */}
        <Box
          sx={{
            px: 2,
            py: 1,
            borderRadius: 2,
            bgcolor: "action.hover",
            display: "flex",
            alignItems: "center",
            gap: 1,
            minWidth: 180,
            justifyContent: "center",
          }}
        >
          <FactoryIcon fontSize="small" color="primary" />
          <Box>
            <Box
              sx={{
                fontSize: "0.7rem",
                color: "text.secondary",
                lineHeight: 1,
              }}
            >
              Plant
            </Box>
            <Box sx={{ fontWeight: 700, fontSize: "0.95rem" }}>
              {plant?.name || "-"}
            </Box>
          </Box>
        </Box>

        {/* Content Toggle */}
        <ToggleButtonGroup
          value={mode}
          exclusive
          onChange={handleModeChange}
          size="small"
          sx={{
            bgcolor: "action.hover",
            borderRadius: 2,
            p: 0.5,
            "& .MuiToggleButton-root": {
              borderRadius: "8px !important",
              border: "none !important",
              px: 2,
              py: 1,
              fontWeight: 600,
              color: "text.secondary",
              transition: "all 0.2s",
              "&.Mui-selected": {
                bgcolor: "primary.main",
                color: "primary.contrastText",
                boxShadow: 1,
                "&:hover": {
                  bgcolor: "primary.dark",
                },
              },
            },
          }}
        >
          <ToggleButton value="Reconcile">Material Reconcile</ToggleButton>
          <ToggleButton value="Compare">Compare</ToggleButton>
          <ToggleButton value="Search">Search</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}
